import {
  Box,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updateUserRequest } from "store/user/reducer";
import { isUpdatingUserSelector, userSelector } from "store/user/selector";
import { AuthInput } from "components/auth/AuthInput";

type CustomerProfileFormInputs = {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  password: string;
};

export default function CustomerProfileDetailsForm() {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const isUpdating = useSelector(isUpdatingUserSelector);
  const initialValues: CustomerProfileFormInputs = {
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    phone: user?.phone || "",
    email: user?.email || "",
    password: "",
  };

  const onUpdateUser = (values: any) => {
    dispatch(
      updateUserRequest({
        user_id: user.user_id,
        user_details: values,
      })
    );
  };

  return (
    <FormControl mt="40px">
      <Formik
        initialValues={initialValues}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={(values) => {
          console.log(values);
          onUpdateUser(values);
        }}
      >
        {({ handleSubmit, errors, submitCount }) => (
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <FormControl
              isInvalid={submitCount > 0 && !!errors.first_name}
              mb="12px"
            >
              <FormLabel
                fontSize="12px"
                lineHeight="15px"
                fontWeight="400"
                color="#8E8C8C"
                textTransform="capitalize"
                padding="5px"
                bgColor="#FFF"
                mr="0px"
                width="fit-content"
                position="relative"
                zIndex="10"
                ml="30px"
                mb="-13px"
              >
                First Name
              </FormLabel>
              <Field name="first_name" validate={(value: any) => {
                let error;
                if (value.length < 1) {
                  error = "First Name is required.";
                }
                return error;
              }}>
                {({ field }: any) => (
                  <AuthInput
                    {...field}
                    role="customer"
                    chakraVariant="authCustomerNew"
                    type="text"
                    id="first_name"
                    placeholder="First Name"
                    isInvalid={submitCount > 0 && !!errors.first_name}
                  />
                )}
              </Field>

            </FormControl>

            <FormControl
              isInvalid={submitCount > 0 && !!errors.last_name}
              mb="12px"
            >
              <FormLabel
                fontSize="12px"
                lineHeight="15px"
                fontWeight="400"
                color="#8E8C8C"
                textTransform="capitalize"
                padding="5px"
                bgColor="#FFF"
                mr="0px"
                width="fit-content"
                position="relative"
                zIndex="10"
                ml="30px"
                mb="-13px"
              >
                Last Name
              </FormLabel>
              <Field name="last_name" validate={(value: any) => {
                let error;
                if (value.length < 1) {
                  error = "Last Name is required.";
                }
                return error;
              }}>
                {({ field }: any) => (
                  <AuthInput
                    {...field}
                    role="customer"
                    chakraVariant="authCustomerNew"
                    type="text"
                    id="last_name"
                    placeholder="Last Name"
                    isInvalid={submitCount > 0 && !!errors.last_name}
                  />
                )}
              </Field>
            </FormControl>

            <FormControl isInvalid={submitCount > 0 && !!errors.phone} mb="12px">
              <FormLabel
                fontSize="12px"
                lineHeight="15px"
                fontWeight="400"
                color="#8E8C8C"
                textTransform="capitalize"
                padding="5px"
                bgColor="#FFF"
                mr="0px"
                width="fit-content"
                position="relative"
                zIndex="10"
                ml="30px"
                mb="-13px"
              >
                Phone Number
              </FormLabel>
              <Field name="phone" validate={(_: any): string | undefined => undefined}>
                {({ field }: any) => (
                  <AuthInput
                    {...field}
                    role="customer"
                    chakraVariant="authCustomerNew"
                    type="tel"
                    id="phone"
                    placeholder="Phone Number"
                    isInvalid={submitCount > 0 && !!errors.phone}
                  />
                )}
              </Field>
            </FormControl>

            <FormControl isInvalid={submitCount > 0 && !!errors.email} mb="12px">
              <FormLabel
                fontSize="12px"
                lineHeight="15px"
                fontWeight="400"
                color="#8E8C8C"
                textTransform="capitalize"
                padding="5px"
                bgColor="#FFF"
                mr="0px"
                width="fit-content"
                position="relative"
                zIndex="10"
                ml="30px"
                mb="-13px"
              >
                Email
              </FormLabel>
              <Field name="email" validate={(value: any) => {
                let error;
                if (value.length < 1) {
                  error = "Email Address is required.";
                }
                return error;
              }}>
                {({ field }: any) => (
                  <AuthInput
                    {...field}
                    role="customer"
                    chakraVariant="authCustomerNew"
                    type="email"
                    id="email"
                    placeholder="Email Address"
                    isInvalid={submitCount > 0 && !!errors.email}
                  />
                )}
              </Field>
            </FormControl>

            <FormControl
              // isInvalid={!!errors.password && touched.password}
              mb="12px"
            >
              <FormLabel
                fontSize="12px"
                lineHeight="15px"
                fontWeight="400"
                color="#8E8C8C"
                textTransform="capitalize"
                padding="5px"
                bgColor="#FFF"
                mr="0px"
                width="fit-content"
                position="relative"
                zIndex="10"
                ml="30px"
                mb="-13px"
              >
                Password
              </FormLabel>
              <Field name="password">
                {({ field }: any) => (
                  <AuthInput
                    {...field}
                    role="customer"
                    chakraVariant="authCustomerNew"
                    type="password"
                    id="password"
                    placeholder="Change Password"
                  />
                )}
              </Field>
            </FormControl>

            <Box mt="20px" textAlign="right">
              <Button
                type="submit"
                bgColor="#8E8C8C"
                padding="15px 40px"
                fontWeight="700"
                fontSize="14px"
                lineHeight="17px"
                color="#FFF"
                height="48px"
                width="176px"
                borderRadius="50px"
                isLoading={isUpdating}
              >
                Save Changes
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </FormControl>
  );
}
